export const radians = Math.PI / 180;
